import React, { ReactElement, ReactNode } from 'react';
import { navigateToAnotherMfe } from '../../utils/navigationUtils';

export interface ExternalMfeLinkProps {
  route: string;
  children: ReactNode;
  dataTestId?: string;
}

// Allows to navigate user outside the current MFE to a different MFE application.
const ExternalMfeLink = ({
  route,
  children,
  dataTestId,
  ...rest
}: ExternalMfeLinkProps & React.HTMLAttributes<HTMLAnchorElement>): ReactElement => {
  return (
    <a
      href={route}
      onClick={(e) => {
        navigateToAnotherMfe(route);
        e.preventDefault();
      }}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </a>
  );
};

export default ExternalMfeLink;
